import {createAction} from "redux-act";
import {ITournamentReducer} from "modules/reducers";

export const fetchTournamentJSON = createAction();
export const fetchTournamentJSONSuccess = createAction<ITournamentReducer>();
